import AdministrationDisciplines from './AdministrationDisciplines'

export default AdministrationDisciplines
